import type { CreateOwnerRequest, OwnerSummary, UpdateOwnerRequest } from '../../api/types.ts';

export interface OwnerFormState {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
}

export function initialOwnerForm(owner: OwnerSummary | null): OwnerFormState {
  return {
    first_name: owner?.first_name ?? '',
    last_name: owner?.last_name ?? '',
    phone: owner?.phone ?? '',
    email: owner?.email ?? '',
  };
}

/** Returns the first validation problem, or null when the form is submittable. */
export function validateOwnerForm(form: OwnerFormState): string | null {
  if (form.first_name.trim() === '') return 'Enter a first name.';
  if (form.last_name.trim() === '') return 'Enter a last name.';
  return null;
}

/** Create and update share the same wire shape (E2-API-REFERENCE.md); blank
 *  optional fields are OMITTED rather than sent as empty strings, since the
 *  wire type only allows a present string, never null/empty-clear. */
export function buildOwnerPayload(form: OwnerFormState): CreateOwnerRequest & UpdateOwnerRequest {
  const payload: CreateOwnerRequest = {
    first_name: form.first_name.trim(),
    last_name: form.last_name.trim(),
  };
  const phone = form.phone.trim();
  const email = form.email.trim();
  if (phone !== '') payload.phone = phone;
  if (email !== '') payload.email = email;
  return payload;
}

export function ownerDisplayName(owner: OwnerSummary): string {
  return `${owner.first_name} ${owner.last_name}`.trim();
}
